module.exports = __webpack_public_path__ + "static/conspiracyposter-9db060b7fef50044ed86082ce1a2e32f.jpg";